import { Component, EventEmitter, Input, Output } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { v4 as uuidv4 } from "uuid";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { CopyLinesDto } from "../../../../core/models/orders/copyLinesDto";
import { CopySalesOrderRequestDto } from "../../../../core/models/orders/copySalesOrderRequestDto";
import { GetSaleOrderDtoWIthType } from "../../../../core/models/orders/getSaleOrderDtoWIthType";
import { GetSalesOrderWithLinesDto } from "../../../../core/models/orders/getSalesOrderWithLinesDto";
import { SalesOrderLine } from "../../../../core/models/orders/saleOrderLine";
import { SaleOrderLinePortalKeyDto } from "../../../../core/models/orders/saleOrderLinePortalKeyDto";
import { CopyHeaderService } from "../../../../core/services/copy-header.service";
import { DialogModule } from "primeng/dialog";
import { TableModule } from "primeng/table";
import { CommonModule } from "@angular/common";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { LoaderService } from "../../../../core/services/loader.service";
import { AccordionModule } from "primeng/accordion";
import { EnumCopiedFrom } from "../../../../shared/enums/copied-From.enum";

@UntilDestroy()
@Component({
  selector: "jni-copy-header",
  templateUrl: "./copy-header.component.html",
  styleUrls: ["./copy-header.component.scss"],
  imports: [
    DialogModule,
    TableModule,
    CommonModule,
    HidedynamicsdatePipe,
    AccordionModule,
  ],
})
export class CopyHeaderComponent {
  @Input() saleOrderId = "";
  @Input() displayModal = false;
  @Output() closeDialogEvent = new EventEmitter();
  @Output() refreshGridEvent = new EventEmitter();
  @Output() saleOrderRedirect = new EventEmitter<string>();

  salesOrderHeader: GetSaleOrderDtoWIthType[] = [];
  salesOrderLine: SalesOrderLine[] = [];

  SOLinesItem: string[] = [];
  QuotesLinesItem: string[] = [];

  selectedSalesOrderLine!: SalesOrderLine[];
  selectedSalesOrderHeader: GetSaleOrderDtoWIthType =
    {} as GetSaleOrderDtoWIthType;
  getSalesOrderWithLinesDto: GetSalesOrderWithLinesDto[] = [];
  saleOrder: GetSalesOrderWithLinesDto[] = [];

  constructor(
    private _copyLinesService: CopyHeaderService,
    private _loaderService: LoaderService,
    private _toastr: JniToastrService
  ) {}

  closeDialog() {
    //this.selectedSalesOrderHeader = [];
    this.selectedSalesOrderLine = [];
    this.closeDialogEvent.emit();
  }

  getSaleOrder() {
    this._loaderService.setLoaderState(true);
    this._copyLinesService.GetAllSalesOrderWithLines().subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        const lineArray: GetSaleOrderDtoWIthType[] = [];
        if (res.data) {
          this.getSalesOrderWithLinesDto = res.data;
          this.getSalesOrderWithLinesDto.forEach(element => {
            if (element.getSaleOrdersDto) {
              lineArray.push(element.getSaleOrdersDto);
            }
          });
          this.salesOrderHeader = lineArray;
          this._loaderService.setLoaderState(false);
        }
      },
      error: () => {
        this.selectedSalesOrderLine = [];
        this._loaderService.setLoaderState(false);
      },
    });
  }

  getAllSalesOrderHeader() {
    this.salesOrderHeader = [];
    this.salesOrderLine = [];
    this.SOLinesItem = [];
    this.QuotesLinesItem = [];
    this.selectedSalesOrderHeader = {} as GetSaleOrderDtoWIthType;
    this._loaderService.setLoaderState(true);
    this._copyLinesService.getAllSalesOrderHeader().subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res.data) {
          this.salesOrderHeader = res.data;
          this._loaderService.setLoaderState(false);
        }
      },
      error: () => {
        this.selectedSalesOrderLine = [];
        this._loaderService.setLoaderState(false);
      },
    });
  }

  save() {
    this._loaderService.setLoaderState(true);
    const linesArray: SaleOrderLinePortalKeyDto[] = [];

    if (this.selectedSalesOrderLine?.length > 0) {
      this.selectedSalesOrderLine.forEach(x => {
        const line: SaleOrderLinePortalKeyDto = {
          ...x,
          oldPortalKey: x.portalKeyD365,
          portalKeyD365: uuidv4(),
          lineCopiedFrom: EnumCopiedFrom.IsFromOrder,
        };
        linesArray.push(line);
      });
    } else {
      this.salesOrderLine?.forEach(x => {
        const line: SaleOrderLinePortalKeyDto = {
          ...x,
          oldPortalKey: x.portalKeyD365,
          portalKeyD365: uuidv4(),
          lineCopiedFrom: EnumCopiedFrom.IsFromOrder,
        };
        linesArray.push(line);
      });
    }

    const copyLinesDto: CopyLinesDto = {
      salesOrderId: this.selectedSalesOrderHeader.salesOrderIdD365 ?? "",
      saleOrderLinePortalKeyDtos: linesArray,
    };

    const copyLineArray: CopySalesOrderRequestDto = {
      copyLinesDto: copyLinesDto,
      salesOrderNumber: this.selectedSalesOrderHeader.salesOrderIdD365 ?? "",
      copiedFrom: EnumCopiedFrom.IsFromOrder,
    };

    //this.selectedSalesOrderHeader = [];
    this.selectedSalesOrderLine = [];

    this._copyLinesService
      .addHeaderData(copyLineArray)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            //this.refreshGridEvent.emit();
            this._toastr.success("Success", res.message);
            this.closeDialog();
            //const url = '/orders/order-summary/' + res.data.SalesOrderId;
            this.saleOrderRedirect.emit(res?.data?.SalesOrderId ?? "");
            // this.route.navigate([url]);
          } else {
            this._toastr.error("Error", res.message || "Error adding header");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error adding header");
        },
      });
  }

  getLineAgainstHeader() {
    this.salesOrderLine = [];
    this.selectedSalesOrderLine = [];

    if (this.selectedSalesOrderHeader) {
      const linesArray: SalesOrderLine[] = [];
      const index = this.getSalesOrderWithLinesDto.findIndex(
        y =>
          y.getSaleOrdersDto?.salesOrderIdD365 ==
          this.selectedSalesOrderHeader.salesOrderIdD365
      );
      if (index > -1) {
        this.getSalesOrderWithLinesDto[index].salesOrderLines?.forEach(a => {
          linesArray.push(a);
        });
      }
      this.salesOrderLine = linesArray;
    }
  }

  selectRow(checkValue: boolean | undefined, salesOrderIdD365: string) {
    if (checkValue) {
      this.getLineAgainstSaleOrderHeader(salesOrderIdD365);
    } else {
      this.salesOrderLine = [];
      this.selectedSalesOrderLine = [];
      this.QuotesLinesItem = [];
      this.SOLinesItem = [];
    }
  }

  getLineAgainstSaleOrderHeader(salesOrderIdD365: string) {
    this.salesOrderLine = [];

    this._loaderService.setLoaderState(true);
    this._copyLinesService
      .getLineAgainstSaleOrderHeader(salesOrderIdD365 || "")
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            if (res?.data?.salesOrderLine) {
              this.salesOrderLine = res.data.salesOrderLine;
            }
          } else {
            this._toastr.error("Error", res.message || "No line item found");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "No line item found");
        },
      });
  }

  onLineSelect() {
    const SOLinesItem: string[] = [];
    const quotesLinesItem: string[] = [];
    const lines = this.selectedSalesOrderLine.filter(
      y => y.salesOrderIdD365 == this.selectedSalesOrderHeader.salesOrderIdD365
    );
    lines.forEach(line => {
      if (this.selectedSalesOrderHeader.type?.toLowerCase() == "quotes") {
        quotesLinesItem.push(line.externalItemNumberD365 ?? "");
      } else {
        SOLinesItem.push(line.externalItemNumberD365 ?? "");
      }
    });
    this.QuotesLinesItem = quotesLinesItem;
    this.SOLinesItem = SOLinesItem;
  }
}
